"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pickRandomDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var pickRandomDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createPickRandom: _factoriesAny.createPickRandom
};
exports.pickRandomDependencies = pickRandomDependencies;